import React from 'react'
import MiddleLine from '../../img/icons/general-icons/separator_icon_gray.png'
import ReservaText from './reservaText'
import VitalityIndexText from './vitalidadIndexText'
import FunctionalIndexText from './capacidadFuncText'
import EdadBiologicaText from './edadBiologicaText'
import EdadArterialText from './edadArterialText'

export default class DashboardText extends React.Component {
  render() {

    var plan = 'Sin plan de cuidado'
    if (this.props.plan.length > 0) {
      plan = this.props.plan[0][0].text
    }
    return (
      <div className='health-square-container-printable'>
        <div className='header-printable'>
          <div className='section-title'>Análisis y Plan de Cuidado.</div>
        </div>
        <div className='health-squares-printable'>

          <div className='someText'>
            <div className='chart-title-section'>Índice de capacidad funcional</div>
            <EdadBiologicaText propiedades={this.props.propiedades} />
            <FunctionalIndexText propiedades={this.props.propiedades} />
          </div>
          <img className='middleline_printable' src={MiddleLine} />
          <div className='someText'>
            <div className='chart-title-section'>Reserva funcional</div>
            <ReservaText propiedades={this.props.propiedades} />
          </div>
        </div>
        <div className='chart-title-section break-before'>
          Plan de cuidado
          <div className="plancuidado" >{plan.split(/\n/g).map((p)=>{ return <p>{p}</p>})}</div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
DashboardText.propTypes = {
  propiedades: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/DashboardTextComponent.js